// extracted by mini-css-extract-plugin
export var tagLink = "tagLink-module--tagLink--d7d99";
export var tagLinkLight = "tagLink-module--tagLinkLight--205df";